import { useEffect } from 'react'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

const SCRIPT_ID = 'meta-pixel-script'

/**
 * Loads the Meta Pixel base code and fires a PageView.
 */
export function useMetaPixel(pixelId: string): void {
  useEffect(() => {
    if (!pixelId || typeof window === 'undefined') return

    if (!window.fbq) {
      const fbq: any = function (...args: unknown[]) {
        fbq.callMethod
          ? fbq.callMethod.apply(fbq, args)
          : fbq.queue.push(args)
      }
      window.fbq = fbq
      window._fbq = window._fbq || fbq
      fbq.push = fbq
      fbq.loaded = true
      fbq.version = '2.0'
      fbq.queue = []
    }

    if (!document.getElementById(SCRIPT_ID)) {
      const script = document.createElement('script')
      script.id = SCRIPT_ID
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      document.head.appendChild(script)

      const noscript = document.createElement('noscript')
      const img = document.createElement('img')
      img.height = 1
      img.width = 1
      img.style.display = 'none'
      img.alt = ''
      img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
      noscript.appendChild(img)
      document.body.appendChild(noscript)
    }

    window.fbq?.('init', pixelId)
    window.fbq?.('track', 'PageView')
  }, [pixelId])
}

/** Fires a standard or custom Meta Pixel event. */
export function trackPixelEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  window.fbq?.('track', event, params)
}
